import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/enterprise apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const EnterpriseApps = () => {
  const heroData = {
    title: "Enterprise Application Development Services",
    description: "Transform your business operations with custom enterprise applications that drive efficiency, productivity, and growth. We build scalable, secure solutions for large organizations and complex business needs.",
    image: img13,
    imageAlt: "Enterprise Apps",
    features: [
      "Enterprise-grade security",
      "Scalable architecture",
      "System integrations",
      "Workflow automation",
      "Compliance ready",
      "Advanced analytics",
    ],
    pillars: [
      "Robust security and compliance for enterprise data protection",
      "Scalable architecture that supports organizational growth",
      "Seamless integration with existing enterprise systems and workflows",
    ],
  };

  const journeySteps = [
    {
      title: "Enterprise Analysis",
      description: "We conduct comprehensive analysis of your business processes, workflows, and requirements to design tailored enterprise solutions.",
      details: ["Process mapping", "Stakeholder interviews", "Requirements gathering", "Gap analysis", "Technology assessment", "ROI planning"],
    },
    {
      title: "Architecture Design",
      description: "Our architects design scalable, secure enterprise systems with integration capabilities, data management, and compliance features.",
      details: ["System architecture", "Integration design", "Security framework", "Data modeling", "Compliance mapping", "Scalability planning"],
    },
    {
      title: "Agile Development",
      description: "We build enterprise applications using agile methodology with iterative releases, continuous testing, and stakeholder feedback.",
      details: ["Sprint planning", "Iterative development", "Quality assurance", "User acceptance testing", "Documentation", "Change management"],
    },
    {
      title: "Deployment & Support",
      description: "From phased rollout to training and ongoing support, we ensure successful adoption and continuous improvement of your enterprise app.",
      details: ["Phased rollout", "User training", "Change management", "Performance monitoring", "24/7 support", "Continuous optimization"],
    },
  ];

  const capabilities = [
    {
      title: "Business Process Automation",
      content:
        "Custom enterprise solutions that automate workflows, reduce manual tasks, and improve operational efficiency across departments.",
    },
    {
      title: "ERP & CRM Systems",
      content:
        "Enterprise resource planning and customer relationship management systems tailored to your industry and business needs.",
    },
    {
      title: "Enterprise Mobility",
      content:
        "Mobile enterprise applications that empower your workforce with secure access to business systems from anywhere.",
    },
    {
      title: "Data Analytics Platforms",
      content:
        "Business intelligence and analytics solutions that transform data into actionable insights for better decision-making.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "45%", label: "Operational cost reduction" },
      { value: "3x", label: "Productivity improvement" },
      { value: "99.9%", label: "System uptime SLA" },
    ],
    description: "We deliver enterprise applications that drive significant operational improvements, cost reductions, and productivity gains across organizations.",
  };

  const outcomesData = {
    description: "We create enterprise applications that empower organizations with powerful automation, seamless integrations, and data-driven insights for competitive advantage.",
    outcomes: [
      "Custom enterprise application development",
      "Legacy system modernization and migration",
      "Enterprise system integration (SAP, Oracle, Salesforce)",
      "Role-based access control and permissions",
      "Advanced reporting and analytics",
      "24/7 support and SLA guarantees",
    ],
  };

  const whyChooseUs = [
    {
      title: "Enterprise Experience",
      content:
        "Deep expertise in enterprise software development with proven experience serving Fortune 500 companies and large organizations.",
    },
    {
      title: "Security & Compliance",
      content:
        "Enterprise-grade security, data protection, and compliance with industry regulations including GDPR, HIPAA, and SOC 2.",
    },
    {
      title: "Scalable Solutions",
      content:
        "Architecture designed to support thousands of users, handle complex workflows, and integrate with existing enterprise systems.",
    },
    {
      title: "Long-Term Partnership",
      content:
        "Committed to your success with ongoing support, maintenance, optimization, and feature development as your needs evolve.",
    },
  ];

  const faqs = [
    {
      q: "How do you ensure enterprise-level security?",
      a: "We implement multi-layered security including encryption, secure authentication, role-based access control, regular security audits, and compliance with standards like GDPR, HIPAA, and SOC 2.",
    },
    {
      q: "Can you integrate with our existing enterprise systems?",
      a: "Yes! We specialize in integrating with major enterprise platforms like SAP, Oracle, Salesforce, Microsoft Dynamics, and custom legacy systems through APIs, middleware, and ETL processes.",
    },
    {
      q: "What's your approach to enterprise app development?",
      a: "We use agile methodology with iterative development, continuous stakeholder feedback, comprehensive documentation, and phased rollouts to minimize disruption and ensure successful adoption.",
    },
    {
      q: "Do you provide ongoing support after deployment?",
      a: "Absolutely. We offer 24/7 support, SLA-backed maintenance, regular updates, performance monitoring, and continuous optimization to ensure your enterprise app remains reliable and efficient.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Enterprise App Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Enterprise App Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default EnterpriseApps;
